module.exports = __webpack_public_path__ + "img/default_avatar.f72a7901.png";